import React, { useState, useRef } from 'react';
import firebaseService from 'Services/firebaseService';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Page from 'Components/Page';
import history from '../../history';
import { useForm, Controller } from 'react-hook-form';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import FormTextField from 'Components/FormTextField';
import Loading from 'Components/Loading';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextArea from 'Components/Textarea';
import config from 'Config/firebase';
import clsx from 'clsx';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '3%',
    paddingRight: '3%',
    paddingTop: '40px',
  },
  addEditForm: {
    display: 'flex',
    flexDirection: 'column',
  },
  optionalMessage: {
    fontSize: 18,
  },
  headerMessage: {
    backgroundColor: '#efefef',
    margin: '20px 0 20px 0',
  },
  questions: {
    marginTop: '20px',
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: '70px',
    marginRight: '20px',
  },
  photoContainer: {
    marginBottom: '40px',
  },
  optionalFields: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttons: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  fieldTitle: {
    borderBottom: '1px solid rgb(0 0 0 / 42%)',
    paddingBottom: '12px',
  },
  col1: {
    width: '20%',
  },
  col2: {
    width: '20%',
    textAlign: 'center',
  },
  col3: {
    width: '20%',
    textAlign: 'center',
  },
  col4: {
    width: '40%',
    textAlign: 'center',
  },
  textArea: {
    fontSize: 20,
    width: '100%',
    padding: '70px 20px 0 20px',
    fontFamily: '"Lato",sans-serif',
    border: 0,
    borderBottom: '1px solid rgb(0 0 0 / 42%)',
  },
  textAreaLabel: {
    padding: '0 0px',
  },
});

function AddEditCode({
  classes,
  itemDraft,
  setLocalRegistrationConfig,
  updateServerRegistrationConfig,
  path,
  registerProductConfig,
  formId,
}) {
  const { register, handleSubmit, errors, control, setValue, getValues } = useForm({
    // Cannot just do ...RegisterProductConfig here because checkboxes must modify checked
    // property rather than changing the value of them
    defaultValues: {
      introMessage:
        registerProductConfig?.introMessage ||
        'Register your product and receive faster customer service, special offers and more!',
      sku: registerProductConfig?.sku,
      name: registerProductConfig?.name,
      thankYouMessage: registerProductConfig?.thankYouMessage,
      template: registerProductConfig?.template || 'Registration',
    },
  });

  const [loading, setLoading] = useState(false);

  const onSubmit = async data => {
    setLoading(true);

    if (formId) {
      try {
        await updateServerRegistrationConfig(data);
        history.push(`/product-registration/code-details/${formId}`);
        setLoading(false);
      } catch (err) {
        console.warn('Error updated firebase form: ', err);
        return;
      }
    } else {
      try {
        const newCodeData = await firebaseService.createRegistrationCode(data);

        history.push(`/product-registration/code-details/${newCodeData.regCodeId}`);
        setLoading(false);
      } catch (err) {
        console.warn('Contact server error: ', err);
        return;
      }
    }
  };

  const onPreview = async data => {
    setLocalRegistrationConfig({ ...getValues(), preview: true });
    history.push('/product-registration/register');
  };

  function changeTemplate(e) {
    let message;
    switch (e.target.value) {
      case 'Registration':
        message = 'Register your product and receive faster customer service, special offers and more!';
        break;
      case 'Warranty':
        message = 'Register your product and receive 1 year free warranty.';
        break;
      case 'Gift':
        message = 'Register your product and we will receive a free gift!';
        break;
      default:
        console.warn(`No matching field`);
    }

    setValue('introMessage', message);
  }

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      {loading ? (
        <Loading
          type={'bubbles'}
          color={'#ccc'}
          height={'80px'}
          width={'80px'}
          containerHeight={'40vh'}
          containerWidth={'100%'}
          message={'Updating...'}
        />
      ) : (
        <>
          <Typography variant="h2">
            {formId ? `Edit Registration Page: ${itemDraft.info.itemId}` : 'New Registration Page'}
          </Typography>

          <form onSubmit={handleSubmit(onSubmit).bind(this)} className={classes.addEditForm}>
            <FormTextField
              fullWidth
              label="Product Name"
              name="name"
              required
              error={!!errors.name}
              helperText="Enter a product name"
              inputRef={register({
                required: 'Provide the product name',
              })}
              placeholder="Enter the product name"
            />

            <FormTextField
              fullWidth
              label="Your SKU or product Identifier"
              name="sku"
              error={!!errors.sku}
              helperText="Enter your product ID or sku"
              inputRef={register}
              placeholder="Enter your product ID or sku"
            />

            <FormControl>
              <InputLabel htmlFor="template">Use introduction template</InputLabel>
              <Select
                id="template"
                inputProps={{
                  inputRef: ref => {
                    if (!ref) return;
                    register({
                      name: 'template',
                      value: ref.value,
                    });
                  },
                }}
                onChange={changeTemplate}
              >
                <MenuItem key="reg" value="Registration">
                  Registration
                </MenuItem>
                <MenuItem key="war" value="Warranty">
                  Warranty
                </MenuItem>
                <MenuItem key="gif" value="Gift">
                  Gift
                </MenuItem>
                <MenuItem key="cus" value="Custom">
                  Custom
                </MenuItem>
              </Select>
            </FormControl>

            <TextArea
              fullWidth
              label="Edit introduction message"
              name="introMessage"
              margin="normal"
              labelClassName={classes.textAreaLabel}
              className={classes.textArea}
              rows={4}
              cols={57}
              required={true}
              rowsMax={80}
              colsMax={60}
              error={!!errors.introMessage}
              helperText={errors.introMessage && errors.introMessage.message}
              inputRef={register({
                required: 'Enter a message',
                minLength: {
                  value: 1,
                  message: 'Message too short',
                },
              })}
              placeholder=""
            />

            <p className="questions">
              <b>Form Fields to Include</b>
            </p>

            <div className={classes.optionalFields}>
              <p className={clsx(classes.col1, classes.fieldTitle)}>Field</p>
              <p className={clsx(classes.col2, classes.fieldTitle)}>Add this field</p>
              <p className={clsx(classes.col3, classes.fieldTitle)}>Make required</p>
              <p className={clsx(classes.col4, classes.fieldTitle)}></p>

              <p className={classes.col1}>Name</p>

              <div className={classes.col2}>
                <Checkbox name="name" className={classes.checkbox} checked={true} disabled={true} />
              </div>
              <div className={classes.col3}>
                <Checkbox name="name" className={classes.checkbox} checked={true} disabled={true} />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Email</p>

              <div className={classes.col2}>
                <Checkbox name="email" className={classes.checkbox} checked={true} disabled={true} />
              </div>
              <div className={classes.col3}>
                <Checkbox name="email" className={classes.checkbox} checked={true} disabled={true} />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Address</p>

              <div className={classes.col2}>
                <Checkbox
                  name="address"
                  defaultChecked={registerProductConfig.address}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="addressRequired"
                  defaultChecked={registerProductConfig.addressRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Phone</p>

              <div className={classes.col2}>
                <Checkbox
                  name="phone"
                  defaultChecked={registerProductConfig.phone}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="phoneRequired"
                  defaultChecked={registerProductConfig.phoneRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Order Number</p>
              <div className={classes.col2}>
                <Checkbox
                  name="orderNumber"
                  defaultChecked={registerProductConfig.orderNumber}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="orderNumberRequired"
                  defaultChecked={registerProductConfig.orderNumberRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Serial Number</p>
              <div className={classes.col2}>
                <Checkbox
                  name="serialNumber"
                  defaultChecked={registerProductConfig.serialNumber}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="serialNumberRequired"
                  defaultChecked={registerProductConfig.serialNumberRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Purchase Date</p>
              <div className={classes.col2}>
                <Checkbox
                  name="purchaseDate"
                  defaultChecked={registerProductConfig.purchaseDate}
                  serialNumber
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="purchaseDateRequired"
                  defaultChecked={registerProductConfig.purchaseDateRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>

              <p className={classes.col1}>Purchase Price</p>
              <div className={classes.col2}>
                <Checkbox
                  name="purchasePrice"
                  defaultChecked={registerProductConfig.purchasePrice}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <div className={classes.col3}>
                <Checkbox
                  name="purchasePriceRequired"
                  defaultChecked={registerProductConfig.purchasePriceRequired}
                  className={classes.checkbox}
                  inputRef={register}
                  required={false}
                />
              </div>
              <p className={classes.col4}></p>
            </div>

            <FormTextField
              fullWidth
              label="Thank You Message"
              name="thankYouMessage"
              error={!!errors.thankYouMessage}
              helperText={
                errors.thankYouMessage
                  ? errors.thankYouMessage.message
                  : 'Add an optional thank you message to display.'
              }
              inputRef={register({
                required: false,
              })}
              placeholder="Thank you for your registration!"
              multiline
            />

            <div className={classes.buttons}>
              <Button
                type="button"
                variant="contained"
                color="secondary"
                className={classes.button}
                onClick={onPreview}
              >
                Preview
              </Button>

              <Button type="submit" variant="contained" color="primary" className={classes.button}>
                {formId ? 'Update Form' : 'Submit'}
              </Button>
            </div>
          </form>
        </>
      )}
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setLocalRegistrationConfig: actions.setRegistrationConfig,
      updateServerRegistrationConfig: actions.updateRegistrationConfig,
    },
    dispatch,
  );
}

function mapStateToProps({ registerProductConfig }, ownProps) {
  return {
    registerProductConfig,
    formId: ownProps.match.params.id,
    path: ownProps.location.pathname,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(AddEditCode)));
